import { GetterTree } from "vuex";
import { StateInterface } from "src/store";
import { EventsUtilsStateInterface } from "./state";
import { getMutedSwearWords } from "src/modules/utils/recorder/replacer-swear-words";

const getters: GetterTree<EventsUtilsStateInterface, StateInterface> = {
  swearWordsFilter(state, getters, rootState) {
    return (text: string): string => {
      const hasSettingSwearHandlerMode = rootState.settings.list.addSwearHandlerMode?.value;
      if (!hasSettingSwearHandlerMode || !state.regExpSwearWords) return text;
      return getMutedSwearWords(text, state.swearWordsArray, state.regExpSwearWords);
    };
  },
};

export default getters;
